/* definition-footer.tsx generated by @compiled/babel-plugin v0.38.1 */
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./definition-footer.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { Fragment, lazy, Suspense, useState } from 'react';
import { useIntl } from 'react-intl-next';
import { Checkbox } from '@atlaskit/checkbox';
import { FlagGroup } from '@atlaskit/flag';
import { ModalTransition } from '@atlaskit/modal-dialog';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Flex } from '@atlaskit/primitives/compiled';
import { deleteSessionItem, getSessionItem, setSessionItem } from '@atlassian/search-dialog';
import { getFrontendExperiment } from '@atlassian/search-experiment';
import { useAIAnswerContext } from '../../../ai-answer-dialog/ai-answer-context';
import { onClickDisableDefinition } from '../analytics';
import { DefinitionUpdateConfirmationFlag } from '../curated/edit-definition-modal/definition-update-confirmation-flag';
import { EditDefinitionModal } from '../curated/edit-definition-modal/edit-definition-modal';
import { DefinitionEditHistory } from '../curated/edit-history-modal/edit-history-modal';
import { toggleDefinitionErrorPayload } from '../error-analytics';
import { FeedbackButtons } from './feedback-buttons';
import { FeedbackModal } from './feedback-modal';
import { FeedbackOptionsModal } from './feedback-options-modal';
import { AIDefinitionFooterSection, EditedDefinitionFooterSection } from './footer-section';
import { messages } from './messages';
import { useToggleDefinitionSupplier } from './useToggleDefinitionSupplier';
var styles = {
  root: "_11c82smr _1e0c1txw _4cvr1h6o _otyr1b66 _syaz1sqi _19bv1ejb _u5f31ejb"
};
var AkFeedbackFlag = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/product-search-dialog/feedback-flag" */'@atlaskit/feedback-collector').then(function (_ref) {
    var FeedbackFlag = _ref.FeedbackFlag;
    return {
      default: FeedbackFlag
    };
  });
});
var AI_DEFINITION_TOGGLE_CACHE_KEY = 'atlassian.search-ai.ai-definition-toggle';
export var DefinitionFooter = function DefinitionFooter() {
  var _useAIAnswerContext = useAIAnswerContext(),
    answerEditor = _useAIAnswerContext.answerEditor,
    fireAnalyticsEvent = _useAIAnswerContext.fireAnalyticsEvent,
    readingAidsOptions = _useAIAnswerContext.readingAidsOptions,
    isAnswered = _useAIAnswerContext.isAnswered,
    hasError = _useAIAnswerContext.hasError,
    commonAttributes = _useAIAnswerContext.commonAttributes,
    definitionToggleEnabled = _useAIAnswerContext.definitionToggleEnabled,
    sourceProduct = _useAIAnswerContext.sourceProduct;
  var keyPhrase = commonAttributes.query,
    workspaceId = commonAttributes.workspaceId,
    cloudId = commonAttributes.cloudId;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage,
    locale = _useIntl.locale;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showFeedbackOptionsModal = _useState2[0],
    setShowFeedbackOptionsModal = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showEditDefinitionModal = _useState4[0],
    setShowEditDefinitionModal = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showFeedbackModal = _useState6[0],
    setShowFeedbackModal = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showEditHistoryModal = _useState8[0],
    setShowEditHistoryModal = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    displayFlag = _useState0[0],
    setDisplayFlag = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    displaySuccessFlag = _useState10[0],
    setDisplaySuccessFlag = _useState10[1];
  var cachedTermDefinitionDisabled = JSON.parse(getSessionItem(AI_DEFINITION_TOGGLE_CACHE_KEY) || '{}');
  var _useState11 = useState(cachedTermDefinitionDisabled.keyPhrase === keyPhrase),
    _useState12 = _slicedToArray(_useState11, 2),
    termDefinitionDisabled = _useState12[0],
    setTermDefinitionDisabled = _useState12[1];
  var _ref2 = readingAidsOptions || {},
    definitionCurationOptions = _ref2.definitionCurationOptions;
  var editDefinitionEnabled = !!definitionCurationOptions;
  var _getFrontendExperimen = getFrontendExperiment({
      abTestId: 'kd_definitions_ux_uplift_exp'
    }),
    serveDefinitionsUXExp = _getFrontendExperimen.serveExperiment;
  var serveDefinitionUXUpdates = serveDefinitionsUXExp && fg('kd_definitions_ux_uplift_exp_gate');
  var _useToggleDefinitionS = useToggleDefinitionSupplier(),
    toggleDefinition = _useToggleDefinitionS.toggleDefinition;
  var onToggleDefinitionDisable = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            setTermDefinitionDisabled(function (current) {
              return !current;
            });
            _context.next = 4;
            return toggleDefinition({
              workspaceId: workspaceId,
              keyPhrase: keyPhrase,
              isDisabled: !termDefinitionDisabled,
              cloudId: cloudId,
              product: sourceProduct !== null && sourceProduct !== void 0 ? sourceProduct : ''
            });
          case 4:
            if (termDefinitionDisabled) {
              deleteSessionItem(AI_DEFINITION_TOGGLE_CACHE_KEY);
            } else {
              fireAnalyticsEvent(onClickDisableDefinition(commonAttributes));
              setSessionItem(AI_DEFINITION_TOGGLE_CACHE_KEY, JSON.stringify({
                keyPhrase: keyPhrase
              }));
            }
            _context.next = 11;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            setTermDefinitionDisabled(function (current) {
              return !current;
            });
            fireAnalyticsEvent(toggleDefinitionErrorPayload(_context.t0, commonAttributes));
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }));
    return function onToggleDefinitionDisable() {
      return _ref3.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(Fragment, null, !hasError && isAnswered && !serveDefinitionUXUpdates && /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "space-between",
    xcss: styles.root
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(FeedbackButtons, {
    setShowFeedbackOptionsModal: setShowFeedbackOptionsModal,
    setDisplayFlag: setDisplayFlag
  })), definitionToggleEnabled && fg('kd_definitions_toggle_definition') && /*#__PURE__*/React.createElement(Checkbox, {
    isChecked: termDefinitionDisabled,
    label: messages.definition_footer_hide_term_definition_message.defaultMessage,
    value: messages.definition_footer_hide_term_definition_message.defaultMessage,
    onChange: onToggleDefinitionDisable
  })), answerEditor ? /*#__PURE__*/React.createElement(EditedDefinitionFooterSection, {
    setShowEditHistoryModal: setShowEditHistoryModal
  }) : /*#__PURE__*/React.createElement(AIDefinitionFooterSection, null), /*#__PURE__*/React.createElement(ModalTransition, null, showEditHistoryModal && editDefinitionEnabled && /*#__PURE__*/React.createElement(DefinitionEditHistory, {
    curatedDefinitionScopeConfig: definitionCurationOptions.curatedDefinitionScopeConfig,
    onClose: function onClose() {
      return setShowEditHistoryModal(false);
    }
  }), showFeedbackOptionsModal && /*#__PURE__*/React.createElement(FeedbackOptionsModal, {
    setShowFeedbackOptionsModal: setShowFeedbackOptionsModal,
    setShowEditDefinitionModal: setShowEditDefinitionModal,
    setShowFeedbackModal: setShowFeedbackModal,
    editDefinitionEnabled: editDefinitionEnabled
  }), showFeedbackModal && /*#__PURE__*/React.createElement(FeedbackModal, {
    setFeedbackModal: setShowFeedbackModal,
    isCuratedDefinition: !!answerEditor,
    setDisplayFlag: setDisplayFlag
  }), showEditDefinitionModal && editDefinitionEnabled && /*#__PURE__*/React.createElement(EditDefinitionModal, {
    curatedDefinitionScopeConfig: definitionCurationOptions.curatedDefinitionScopeConfig,
    closeEditModal: function closeEditModal() {
      return setShowEditDefinitionModal(false);
    },
    openFeedbackOptionsModal: function openFeedbackOptionsModal() {
      return setShowFeedbackOptionsModal(true);
    },
    onSaveEditModal: function onSaveEditModal() {
      return setDisplaySuccessFlag(true);
    }
  })), displayFlag && /*#__PURE__*/React.createElement(FlagGroup, {
    onDismissed: function onDismissed() {
      return setDisplayFlag(false);
    }
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Fragment, null)
  }, /*#__PURE__*/React.createElement(AkFeedbackFlag, {
    locale: locale,
    description: formatMessage(messages.definition_footer_feedback_flag_description)
  }))), displaySuccessFlag && /*#__PURE__*/React.createElement(DefinitionUpdateConfirmationFlag, {
    onDismissed: function onDismissed() {
      return setDisplaySuccessFlag(false);
    }
  }));
};